// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"RichTextEditor_rich-text-editor__fvPTK","rich-text-editor--short-post-text-field":"RichTextEditor_rich-text-editor--short-post-text-field__ZUlO4"};